import React from 'react';

const CommunityRiktlinjer = () => {
  return (
    <div className="container mx-auto px-4 py-12 max-w-3xl">
      <h1 className="text-3xl font-bold mb-8 text-minnestig-teal">Communityriktlinjer</h1>

      <p className="text-lg text-gray-700 leading-relaxed mb-8">
        På Demenshjältar lyfter vi röster från anhöriga, drabbade och vårdpersonal. Här berättar vi
        om vardagen med demens, delar insikter och skapar igenkänning. Vår ambition är att ge
        stöd, hopp och vägledning – till dig som står mitt i det, och till samhället omkring.
      </p>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">1. Alla berättelser är välkomna</h2>
        <p className="text-gray-700 leading-relaxed">
          Demensresan ser olika ut för alla. På vår hemsida får olika perspektiv ta plats – det finns
          inget rätt eller fel sätt att vara anhörig, drabbad eller medmänniska.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">2. Allt innehåll är öppet – och får spridas</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          Till skillnad från vårt slutna Facebook-community är allt som publiceras här på hemsidan
          publikt. Vi uppmuntrar till att dela artiklar, citat och berättelser vidare – det är så vi skapar
          mer förståelse tillsammans.
        </p>
        <p className="text-gray-700 leading-relaxed">
          <strong>Om du vill citera någon:</strong> länka gärna till originalet och nämn Demenshjältar som källa.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">3. Vi värnar om saklighet och trygghet</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          Vi publicerar personliga upplevelser, vägledning och kunskap.
        </p>
        <p className="text-gray-700 leading-relaxed mb-2">
          Det vi inte gör:
        </p>
        <ul className="list-disc list-inside text-gray-700 leading-relaxed space-y-1 mb-4">
          <li>Publicerar medicinska råd (vi hänvisar till vården för individuell rådgivning)</li>
          <li>Tillåter innehåll som är stötande, diskriminerande eller integritetskränkande</li>
        </ul>
        <p className="text-gray-700 leading-relaxed">
          Vårt redaktionella team granskar allt innan publicering.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">4. Vill du dela din berättelse?</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          Vi tar tacksamt emot berättelser, citat, bilder och reflektioner från dig som vill bidra.
        </p>
        <p className="text-gray-700 leading-relaxed mb-4">
          När du skickar in ditt innehåll godkänner du att det får publiceras på hemsidan och i våra
          andra kanaler (t.ex. sociala medier och nyhetsbrev).
        </p>
        <p className="text-gray-700 leading-relaxed mb-4">
          Du kan välja att vara anonym om du vill.
        </p>
        <p className="text-gray-700 leading-relaxed">
          Skicka in din berättelse till <a href="mailto:hej@demenshjaltar.se" className="text-minnestig-purple hover:underline">hej@demenshjaltar.se</a>
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">5. Din trygghet är vår prioritet</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          Om du ser något på sidan som känns fel eller olämpligt – hör gärna av dig.
        </p>
        <p className="text-gray-700 leading-relaxed mb-4">
          Vi hanterar alla synpunkter med respekt och omtanke.
        </p>
        <p className="text-gray-700 leading-relaxed">
          Mejla oss på: <a href="mailto:hej@demenshjaltar.se" className="text-minnestig-purple hover:underline">hej@demenshjaltar.se</a>
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">6. Tillsammans förändrar vi</h2>
        <p className="text-gray-700 leading-relaxed">
          Genom att dela det vi själva varit med om hjälper vi andra att känna sig mindre ensamma.
          Tack för att du är med och bygger Demenshjältar – ett sammanhang fyllt av empati, mod och
          riktiga berättelser.
        </p>
      </section>
    </div>
  );
};

export default CommunityRiktlinjer;
